import i18next from 'i18next';
import { checkHttpStatus, parseJSON, expiredToken, errorResponse } from '@utils/response';
import { Token, UserCode, Company } from '@utils/users'
import { IsEnglish, GetLanguage } from '@utils/language'

export function getAllListsPage() {

    return fetch('approvalCentral/getAllListsPage', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            language: GetLanguage(),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getListApprovalCentrals(status, requestTypes) {

    return fetch('approvalCentral/getListApprovalCentrals', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            language: GetLanguage(),
            userCode: UserCode(),
            company: Company(),
            status,
            requestTypes,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function approveRequest(centralApprovalId) {
    return fetch('approvalCentral/approveRequest', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            language: GetLanguage(),
            userCode: UserCode(),
            centralApprovalId,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function denyRequest(centralApprovalId, approvalType, comment) {
    return fetch('approvalCentral/denyRequest', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            language: GetLanguage(),
            userCode: UserCode(),
            centralApprovalId,
            approvalType,
            comment,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function updateCommentAndDenyRequest(centralApprovalId, requestId, comment) {
    return fetch('approvalCentral/updateCommentAndDenyRequest', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            language: GetLanguage(),
            userCode: UserCode(),
            centralApprovalId,
            requestId,
            comment,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function updateScheduleGenerationTemplateParameters(firstTemplateNumber, lastTemplateNumber, isSendToPortal, startDate, endDate, employeeCode) {
    return fetch('approvalCentral/updateScheduleGenerationTemplateParameters', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            language: GetLanguage(),
            userCode: UserCode(),
            firstTemplateNumber,
            lastTemplateNumber,
            isSendToPortal,
            startDate,
            endDate,
            employeeCode,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function saveLeaveApprovalCentralRequest(requestId, isToReplace, comment) {
    return fetch('approvalCentral/saveLeaveApprovalCentralRequest', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            language: GetLanguage(),
            userCode: UserCode(),
            requestId,
            isToReplace,
            comment,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function saveShiftExchangeRequestComment(requestId, comment) {
    return fetch('approvalCentral/saveShiftExchangeRequestComment', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            language: GetLanguage(),
            userCode: UserCode(),
            requestId,
            comment,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function updateReadDocument(uid) {
    return fetch('approvalCentral/updateReadDocument', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            uid,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function gettApprovalRequestCalendar(status, requestTypes, otherClassifs, month, year) {

    return fetch('approvalCentral/gettApprovalRequestCalendarList', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            language: GetLanguage(),
            userCode: UserCode(),
            company: Company(),
            status,
            requestTypes,
            otherClassifs,
            month,
            year,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortList(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.descriptionEn.toLowerCase() : a.descriptionFr.toLowerCase()
        const nameB = IsEnglish() ? b.descriptionEn.toLowerCase() : b.descriptionFr.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortListByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.value
        const nameB = b.value
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function formatRange(isEnglish, startIso, endIso, request, showYear = false) {
    let startTime, endTime;
    const culture = isEnglish ? 'en-EN' : 'fr-FR';
    const isPartial = request && request.isRequestPartial;
    const today = new Date();
    const start = new Date(startIso);
    const end = new Date(endIso);
    const dayStart = start.getDate();
    const dayEnd = end.getDate();
    const monthFormatter = new Intl.DateTimeFormat(culture, { month: 'long' });
    const monthName = monthFormatter.format(start);
    const year = start.getFullYear();
    const fromDesc = `${i18next.t("common:from")}`;
    const from2Desc = `${i18next.t("common:from2")}`;
    const toDesc = `${i18next.t("common:to")}`;
    const atDesc = `${i18next.t("common:at")}`;
    const theDesc = `${i18next.t("common:the")}`;

    const sameMonth = today.getFullYear() === year
        && end.getFullYear() === year
        && start.getMonth() === end.getMonth();

    if (isPartial) { //Partial
        startTime = request.startTimeFormatted;
        endTime = request.endTimeFormatted;

        if (startTime && endTime) {
            return isEnglish ?
                `${monthName} ${dayStart} ${from2Desc} ${startTime} ${atDesc} ${endTime}` :
                `${theDesc} ${dayStart} ${monthName} ${from2Desc} ${startTime} â ${endTime}`;
        }
    }

    if (!endIso || (sameMonth && dayStart == dayEnd)) {//Same Day
        return isEnglish ?
            `${monthName} ${dayStart}` :
            `Le ${dayStart} ${monthName}`;
    }

    if (sameMonth) {
        return showYear ?
            `${fromDesc} ${dayStart} ${toDesc} ${dayEnd} ${monthName} ${year}` :
            `${fromDesc} ${dayStart} ${toDesc} ${dayEnd} ${monthName}`;
    } else {
        const fullFormatter = new Intl.DateTimeFormat(culture, { day: 'numeric', month: 'long', year: 'numeric' });
        return `${fromDesc} ${fullFormatter.format(start)} ${toDesc} ${fullFormatter.format(end)}`;
    }
}